
<pre style="color: var(--mdc-dialog-supporting-text-color, rgba(0, 0, 0))">{{ output }}</pre>

<button mat-button [mat-dialog-close]="" cdkFocusInitial>Close</button>
